var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("规则配置")]),
      _c("div", { staticClass: "rule-block" }, [
        _c(
          "div",
          {
            staticClass: "status-tip",
            staticStyle: { "margin-bottom": "8px" },
          },
          [_vm._v("满足条件触发")]
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  "margin-bottom": "18px",
                  width: "168px",
                  "text-align": "right",
                },
                model: {
                  value: _vm.redRuleFlags.bet,
                  callback: function ($$v) {
                    _vm.$set(_vm.redRuleFlags, "bet", $$v)
                  },
                  expression: "redRuleFlags.bet",
                },
              },
              [_vm._v("每日投注达到")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "redRuleValues.today_bet_amount",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 2,
                    controls: false,
                    disabled: !_vm.redRuleFlags.bet,
                  },
                  model: {
                    value: _vm.redRuleValues.today_bet_amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.redRuleValues, "today_bet_amount", $$v)
                    },
                    expression: "redRuleValues.today_bet_amount",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rule-row" },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  "margin-bottom": "18px",
                  width: "168px",
                  "text-align": "right",
                },
                model: {
                  value: _vm.redRuleFlags.payin,
                  callback: function ($$v) {
                    _vm.$set(_vm.redRuleFlags, "payin", $$v)
                  },
                  expression: "redRuleFlags.payin",
                },
              },
              [_vm._v("今日存款达到")]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "redRuleValues.today_payin_amount",
                  "label-width": "0",
                },
              },
              [
                _c("el-input-number", {
                  staticClass: "rule-input-num",
                  attrs: {
                    min: 0,
                    precision: 2,
                    controls: false,
                    disabled: !_vm.redRuleFlags.payin,
                  },
                  model: {
                    value: _vm.redRuleValues.today_payin_amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.redRuleValues, "today_payin_amount", $$v)
                    },
                    expression: "redRuleValues.today_payin_amount",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "redRuleValues.countdown",
            "label-width": "180px",
            label: "每次红包雨时长",
          },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 0, controls: false },
            model: {
              value: _vm.redRuleValues.countdown,
              callback: function ($$v) {
                _vm.$set(_vm.redRuleValues, "countdown", $$v)
              },
              expression: "redRuleValues.countdown",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("秒")]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "redRuleValues.count_limit",
            "label-width": "180px",
            label: "每次可抢红包上限个数",
          },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 0, controls: false },
            model: {
              value: _vm.redRuleValues.count_limit,
              callback: function ($$v) {
                _vm.$set(_vm.redRuleValues, "count_limit", $$v)
              },
              expression: "redRuleValues.count_limit",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("个")]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "redRuleValues.duration",
            "label-width": "180px",
            label: "满足条件后倒计时",
          },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 0, controls: false },
            model: {
              value: _vm.redRuleValues.duration,
              callback: function ($$v) {
                _vm.$set(_vm.redRuleValues, "duration", $$v)
              },
              expression: "redRuleValues.duration",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("分钟")]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "redRuleValues.multiple",
            "label-width": "180px",
            label: "奖励稽核倍数",
          },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 2, controls: false },
            model: {
              value: _vm.redRuleValues.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.redRuleValues, "multiple", $$v)
              },
              expression: "redRuleValues.multiple",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("倍")]),
        ],
        1
      ),
      _c("el-form-item", {
        staticStyle: { display: "none" },
        attrs: { prop: "redRuleAtLeastOne" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }